export const PLATFORM_BLOCK_ANCHOR_ID = 'platform-block'

type ScrollToAnchorWhenReadyOptions = {
  maxAttempts?: number
  intervalMs?: number
}

export function scrollToAnchor(
  anchorId: string,
  options?: ScrollIntoViewOptions
): boolean {
  const element = document.querySelector(`#${CSS.escape(anchorId)}`)
  if (!element) {
    return false
  }

  element.scrollIntoView({
    block: 'start',
    ...options
  })
  return true
}

export function scrollToAnchorWhenReady(
  anchorId: string,
  options?: ScrollToAnchorWhenReadyOptions
): () => void {
  const maxAttempts = options?.maxAttempts ?? 40
  const intervalMs = options?.intervalMs ?? 50
  let attempts = 0
  let timer: ReturnType<typeof setTimeout> | undefined

  const tryScroll = () => {
    if (scrollToAnchor(anchorId)) {
      return
    }

    attempts += 1
    if (attempts < maxAttempts) {
      timer = setTimeout(tryScroll, intervalMs)
    }
  }

  tryScroll()

  return () => {
    if (timer) {
      clearTimeout(timer)
    }
  }
}
